<template>
    <div
        v-if="limitOptions.length > 1 || showPages"
        class="kgr-postfix kgr-postfix--gutters kgr-postfix--center animated fadeIn"
    >
        <div
            v-if="showPages"
            class="kgr-postfix__fluid"
        >
        </div>
        <div
            v-if="showPages"
            class="kgr-postfix__fixed"
        >
            <nav class="kgr-pagination">
                <div
                    v-for="page in pages"
                    :key="page"
                >
                    <span
                        v-if="page === 'ellipsis'"
                        class="kgr-pagination__item"
                    >
                        <kgr-icon
                            icon-class="more-horizontal"
                            small
                            disabled
                        />
                    </span>
                    <span
                        v-else-if="page === currentPage"
                        class="kgr-pagination__item is-active"
                    >
                        {{ page }}
                    </span>
                    <button
                        v-else
                        class="kgr-pagination__item"
                        @click="onChange((page - 1) * limit)"
                    >
                        {{ page }}
                    </button>
                </div>
            </nav>
        </div>
        <div
            v-if="showLimitOptions"
            class="kgr-postfix__fixed"
        >
            <select
                v-model="limit"
                class="kgr-select kgr-select--small"
                @change="onChange()"
            >
                <option
                    v-for="limitOption in limitOptions"
                    :key="limitOption.name"
                    :value="limitOption.value"
                    class="kgr-select__option"
                >
                    {{ limitOption.name }}
                </option>
            </select>
        </div>

        <div class="kgr-postfix__fixed">
            <div class="kgr-pager">
                <button
                    v-if="limit"
                    :disabled="disablePrevious"
                    class="kgr-pager__button"
                    @click="decreaseOffset"
                >
                    <kgr-icon
                        icon-class="arrow-left"
                        small
                        circle
                    />
                </button>

                <div class="kgr-pager__counter">
                    {{ countText }}
                </div>
                <button
                    v-if="limit"
                    :disabled="disableNext"
                    class="kgr-pager__button"
                    @click="increaseOffset"
                >
                    <kgr-icon
                        icon-class="arrow-right"
                        small
                        circle
                    />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import KgrIcon from './icon/Icon';

export default {
    name: 'KgrPaginator',
    components: {
        'kgr-icon': KgrIcon,
    },
    props: {
        value: {
            type: Object,
            required: false,
            default: () => {
                return {
                    limit: 25,
                    offset: 0,
                };
            },
            example: {
                limit: 25,
                offset: 0,
            },
        },
        length: {
            type: Number,
            required: true,
            example: 250,
        },
        showLimitOptions: {
            type: Boolean,
            required: false,
            default: true,
        },
        showPages: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            limit: null,
            offset: 0,
            allLimitOptions: [
                {
                    value: 10,
                    name: 10,
                },
                {
                    value: 25,
                    name: 25,
                },
                {
                    value: 50,
                    name: 50,
                },
                {
                    value: 100,
                    name: 100,
                },
                {
                    value: 500,
                    name: 500,
                },
                {
                    value: 1000,
                    name: 1000,
                },
                {
                    value: 2000,
                    name: 2000,
                },
                {
                    value: 5000,
                    name: 5000,
                },
                {
                    value: null,
                    name: this.$t('Alle Einträge'),
                },
            ],
        };
    },
    computed: {
        limitOptions() {
            return this.allLimitOptions.filter((limitOption) => !limitOption.value || limitOption.value < this.length);
        },
        countText() {
            let length = !this.value.limit ? this.length : this.value.offset + this.value.limit;
            length = length > this.length ? this.length : length;

            return this.$t('%{count} von %{length}', {
                count: `${this.value.offset + 1} - ${length}`,
                length: this.length,
            });
        },
        disablePrevious() {
            return this.value.offset < 1;
        },
        disableNext() {
            return this.length <= this.value.offset + this.value.limit;
        },
        totalPages() {
            if (!this.limit) {
                return 1;
            }
            return Math.ceil(this.length / this.limit);
        },
        pages() {
            const pages = [];
            const total = this.totalPages;

            if (total <= 7) {
                for (let i = 1; i <= total; i++) {
                    pages.push(i);
                }
            } else {
                pages.push(1, 2, 3);

                pages.push('ellipsis');

                pages.push(total - 2, total - 1, total);
            }

            return pages;
        },
        currentPage() {
            return Math.floor(this.value.offset / this.limit) + 1;
        },
    },
    watch: {
        value: {
            immediate: true,
            handler() {
                this.limit = this.value.limit;
            },
        },
        length() {
            if (this.length < this.limit) {
                this.limit = null;

                this.limitOptions.forEach((limitOption) => {
                    if (limitOption.value && limitOption.value <= this.length) {
                        this.limit = limitOption.value;
                    }
                });

                this.onChange();
            }
        },
    },
    methods: {
        onChange(offset) {
            if (typeof offset === 'undefined') {
                offset = 0;
            }

            const settings = {
                limit: this.limit,
                offset,
            };
            this.$emit('input', settings);
            this.$nextTick(() => {
                this.$emit('post-input', settings);
            });
        },
        increaseOffset() {
            const offset = this.value.offset + this.value.limit;
            this.onChange(offset > this.length ? this.length : offset);
        },
        decreaseOffset() {
            const offset = this.value.offset - this.value.limit;
            this.onChange(offset < 0 ? 0 : offset);
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    select {
    width: auto;
    height: 30px;
}

.inline {
    display: inline-flex;
}

.mr {
    margin-right: 10px;
}
</style>
